<div
    class="fixed inset-0 z-[999999] flex items-center justify-center bg-[rgb(6,44,82)] text-gray-50">
    <div class="flex max-w-3xl flex-col items-center p-8">
        <img
            src="assets/images/logos/hippo-data.png"
            alt="hippo data"
            class="mb-8 w-[120px] max-w-[120px]" />

        <mat-icon
            [svgIcon]="'heroicons_outline:wrench-screwdriver'"
            class="mb-8 !h-12 !w-12 text-[#1e96f7]">
        </mat-icon>

        @if (maintenanceService.status().message) {
            <p
                class="m-0 mb-8 text-center text-base leading-relaxed text-gray-300">
                {{ maintenanceService.status().message }}
            </p>
        }

        <div class="flex flex-col items-stretch gap-8 md:flex-row md:gap-0">
            <!-- Deutsch -->
            <div class="flex-1 text-center md:pr-8">
                <h2 class="m-0 mb-4 text-2xl font-semibold text-gray-50">
                    Wartungsarbeiten
                </h2>

                @if (!maintenanceService.status().message) {
                    <p class="m-0 mb-4 text-base leading-relaxed text-gray-300">
                        Das System wird derzeit gewartet. Bitte versuchen Sie es
                        später erneut.
                    </p>
                }

                @if (maintenanceService.status().endDate) {
                    <div
                        class="mb-4 flex flex-col items-center gap-1 rounded-lg border border-[rgba(30,150,247,0.2)] bg-[rgba(30,150,247,0.1)] px-6 py-3">
                        <span
                            class="text-xs font-medium uppercase tracking-wider text-gray-400">
                            Voraussichtliches Ende:
                        </span>
                        <span class="text-lg font-semibold text-[#1e96f7]">
                            {{
                                maintenanceService.status().endDate
                                    | date: 'dd.MM.yyyy HH:mm'
                            }}
                        </span>
                    </div>
                }

                <p class="m-0 text-sm text-gray-400">
                    Die Seite wird automatisch aktualisiert, sobald das System
                    wieder verfügbar ist.
                </p>
            </div>

            <!-- Divider -->
            <div class="hidden w-px self-stretch bg-white/10 md:block"></div>

            <!-- English -->
            <div class="flex-1 text-center md:pl-8">
                <h2 class="m-0 mb-4 text-2xl font-semibold text-gray-50">
                    System Maintenance
                </h2>

                @if (!maintenanceService.status().message) {
                    <p class="m-0 mb-4 text-base leading-relaxed text-gray-300">
                        The system is currently undergoing maintenance. Please
                        try again later.
                    </p>
                }

                @if (maintenanceService.status().endDate) {
                    <div
                        class="mb-4 flex flex-col items-center gap-1 rounded-lg border border-[rgba(30,150,247,0.2)] bg-[rgba(30,150,247,0.1)] px-6 py-3">
                        <span
                            class="text-xs font-medium uppercase tracking-wider text-gray-400">
                            Expected end:
                        </span>
                        <span class="text-lg font-semibold text-[#1e96f7]">
                            {{
                                maintenanceService.status().endDate
                                    | date: 'dd.MM.yyyy HH:mm'
                            }}
                        </span>
                    </div>
                }

                <p class="m-0 text-sm text-gray-400">
                    The page will automatically refresh once the system is
                    available again.
                </p>
            </div>
        </div>

        <div class="mt-8 flex w-14 items-center justify-between">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>
</div>
